import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Button } from 'primereact/button'
import { formatDateMonthTime } from 'modules'
import { setIsNewProgrammeAction, setEpisodeFetchStatusAction, setEpisodeFetchResultsAction, setAudiovisualRefreshAction, clearProgrammeDraftResultsAction, clearProgrammeDraftResultsEpisodesAction } from './store/actions'
import { selectEpisodeFetchRequest, selectAudioVisualRefresh, selectAudioVisualResultHasChanges } from './store/selectors'
import { confirmPopup } from 'primereact/confirmpopup'
import DataEntry from 'api/DataEntry/AudioVisual'
// TODO: Incomplete feature - Episode History Modal

// ReSharper disable once InconsistentNaming
export const EpisodeDetailsHeader = ({ resultsDataForEdit, isNewProgramme, isEpisodeForm }) => {

    const handleViewHistory = () => {
        // TODO: Incomplete feature - Episode History
    }

    const refresh = useSelector(selectAudioVisualRefresh)
    const draftAvailable = useSelector(selectAudioVisualResultHasChanges)
    const dispatch = useDispatch()
    const setAudiovisualRefresh = (status) => dispatch(setAudiovisualRefreshAction(status))
    const clearProgrammeDraftResults = () => dispatch(clearProgrammeDraftResultsAction())
    const clearEpisodeDraftResults = () => dispatch(clearProgrammeDraftResultsEpisodesAction())
    
    const handleRefresh = (event) => {
        if (draftAvailable) {
            confirmPopup({
                target: event.currentTarget,
                message: 'Refreshing will discard any unsaved changes. Do you want to continue?',
                icon: 'pi pi-info-circle',
                defaultFocus: 'reject',
                acceptClassName: 'p-button-danger',
                accept: () => {
                    clearProgrammeDraftResults()
                    clearEpisodeDraftResults()
                    setAudiovisualRefresh(true)
                },
            })
        } else {
            setAudiovisualRefresh(true)
        }
    }

    if (refresh) {
        if (isEpisodeForm) {
            return (
                <DataEntry
                    setNewProgrammeStatus={setIsNewProgrammeAction}
                    setStatusAction={setEpisodeFetchStatusAction}
                    setOriginalResultAction={setEpisodeFetchResultsAction}
                    requestSelector={selectEpisodeFetchRequest}
                    setRefreshAction={setAudiovisualRefresh}
                />
            )
        }
        return null
    }

    return (
        <div className='details-dashboard col-12'>
            <div className='details-dashboard-cpt text-center col-1 mt-1'>
                <span className='details-dashboard-label mt-4'>Total Episodes</span>
                <span className='details-dashboard-data-lg t-1'>{resultsDataForEdit && (resultsDataForEdit.episodesCount ?? (resultsDataForEdit.episodes && Object.keys(resultsDataForEdit.episodes).length))}</span>
            </div>          
            <div className='details-dashboard-cpt text-center col-1 offset-1' style={{ marginTop: '2.5rem' }} >
                <Button
                    id={'_container_programmeDashboard_av_Refresh'}
                    label="Refresh"
                    icon="fa-light fa-refresh"
                    onClick={handleRefresh}
                    disabled={isNewProgramme}
                >
                </Button>
            </div>
            <div className='details-dashboard-cpt col-3 offset-4'>
                <span className="title lh-lg mb-1">History</span>
                <ul>
                    <li>
                        <span className="details-dashboard-label-in">Created by:</span>
                        <span className="details-dashboard-data-in">{resultsDataForEdit && resultsDataForEdit.createdBy}</span>
                    </li><li>
                        <span className="details-dashboard-label-in">Date Created:</span>
                        <span className="details-dashboard-data-in">{resultsDataForEdit && !isNewProgramme && formatDateMonthTime(resultsDataForEdit.createdOn)}</span>
                    </li><li>
                        <span className="details-dashboard-label-in">Modified by:</span>
                        <span className="details-dashboard-data-in">{resultsDataForEdit && resultsDataForEdit.updatedBy}</span>
                    </li><li>
                        <span className="details-dashboard-label-in">Last Modified:</span>
                        <span className="details-dashboard-data-in">{resultsDataForEdit && !isNewProgramme && formatDateMonthTime(resultsDataForEdit.updatedOn)}</span>
                    </li>
                </ul>
            </div>
            <div className='details-dashboard-cpt text-center col-2'>
                <br />
                <br />
                <Button
                    label="View History"
                    icon="fa-solid fa-clock-rotate-left"
                    className="ml-3"
                    raised
                    onClick={() => handleViewHistory()}
                    disabled={isNewProgramme}
                />
            </div>
            {/* TODO: Incomplete feature - Episode History */}
        </div>
    )
}
